











import Vue from 'vue';
import i18n from 'vue-i18n';
import tippy, { roundArrow, hideAll } from 'tippy.js';
import 'tippy.js/dist/svg-arrow.css';

Vue.use(i18n);

export default {
    name: 'CoTippy',
    props: {
        //pass options object according to the tippy.js documentation
        //docs: https://atomiks.github.io/tippyjs/
        tippyOptions: {
            type: Object,
            default() {
                return {};
            },
        },
        text: {
            type: String,
            default: null,
        },
        hideAllOnShow: {
            type: Boolean,
            default: true,
        },
        triggerId: {
            type: String,
            default: null,
        },
        disabled: {
            // optionally disable the tooltip
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            id: null,
            tippyInstance: null,
            defaultStyles: this.$slots.content ? false : true,
            arrowElem: null,
        };
    },
    mounted() {
        this.id = `tippy${this._uid}`;
        const that = this;
        const options = {
            content: this.text || this.$refs.content,
            arrow: roundArrow,
            onShow(instance) {
                if (this.hideAllOnShow) {
                    hideAll({
                        duration: 0,
                        exclude: instance,
                    });
                }
                that.$emit('show', instance);
            },
            onShown(instance) {
                that.$emit('shown', instance);
            },
            onHide(instance) {
                that.$emit('hide', instance);
            },
            onHidden(instance) {
                that.$emit('hidden', instance);
            },
            // Interactive popups must stay in their owning dialog's focus scope.
            appendTo: () => (this.tippyOptions.interactive && this.$el.closest('[role="dialog"]')) || document.body,
            duration: 0,
            theme: this.$slots.content ? 'custom' : 'default',
            ...this.tippyOptions,
        };
        this.$nextTick(() => {
            if (!this.disabled) {
                this.tippyInstance = tippy(`#${this.triggerId || this.id}`, options)[0];
            }
        });
    },
    beforeDestroy() {
        if (this.tippyInstance) {
            this.tippyInstance.destroy();
        }
    },
    watch: {
        text() {
            this.refreshContent();
        },
        '$i18n.locale'() {
            // Re-apply translated tooltip content after locale changes without remounting the trigger.
            this.refreshContent();
        },
    },
    methods: {
        refreshContent() {
            if (!this.tippyInstance) return;
            this.tippyInstance.setProps({
                content: this.text || this.$refs.content,
            });
        },
        show() {
            if (!this.tippyInstance) return;
            this.tippyInstance.show();
        },
        hide() {
            if (!this.tippyInstance) return;
            this.tippyInstance.hide();
        },
        hideAll() {
            if (!this.tippyInstance) return;
            this.tippyInstance.hide();
        },
        setProps(props) {
            if (!this.tippyInstance) return;
            this.tippyInstance.setProps(props);
        },
    },
};
